import { useState } from 'react';

import { FileState } from './types';

interface UseFileUploaderDropzoneParams {
  initialFileUrls?: string[];
}

export function useFileUploaderDropzone(
  { initialFileUrls }: UseFileUploaderDropzoneParams = {
    initialFileUrls: undefined,
  }
) {
  const [files, setFiles] = useState<Array<FileState>>([]);
  const [uploadedFileUrls, setUploadedFileUrls] = useState(initialFileUrls);

  const isLoading = files.some(({ state }) => state !== 'finished');

  const isFilesEmpty = files.length === 0 && uploadedFileUrls?.length === 0;

  return {
    isLoading,
    isFilesEmpty,
    files,
    setFiles,
    uploadedFileUrls,
    setUploadedFileUrls,
  };
}
